<div *ngIf="isSuccess" class="text-subscription">{{'PAYMENT.SUCCESS'|translate}}</div>
<div *ngIf="!isSuccess" class="text-subscription">{{'PAYMENT.FAILED'|translate}}</div>

<div class="link">
    <a href="/webplatform/my-roulettes">{{'PAYMENT.TO_MY_ROULETTES' | translate}}
    </a>
</div>